import Vue from 'vue';

import VueRouter, { Route } from 'vue-router';
import VueMeta from 'vue-meta';

import { store } from '@/store';

import { navigationRedirect } from './navigation-redirect';
import { routes } from './routes';
import { Position, PositionResult } from 'vue-router/types/router';

Vue.use(VueRouter);
Vue.use(VueMeta, {
	refreshOnceOnNavigation: true
});

const DEFAULT_POSITION = { x: 0, y: 0 };

const router = new VueRouter({
	mode: 'history',
	routes,
	scrollBehavior(to: Route, from: Route, savedPosition: void | Position) {
		if (to.hash) {
			return new Promise<PositionResult>((resolve) => {
				setTimeout(() => {
					resolve({
						selector: to.hash,
						behavior: 'smooth'
					});
				}, 200);
			});
		}

		return savedPosition || DEFAULT_POSITION;
	}
});

router.beforeEach(async(to, from, next) => {
	document.title = to.meta?.title ?? 'Annuaire des radiologues | CNAM';
	store.dispatch('notification/clear');

	navigationRedirect(to, from, next);
});

export { router };
